import React, { useRef } from "react";
import vedio from "../CrossGame/cross.mp4";

const Cross = ({ onVideoStop }) => {
  const videoRef = useRef(null);

  const handleVideoLoaded = () => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 2.5;
      videoRef.current.play();
    }
  };

  const handleVideoEnd = () => {
    onVideoStop();
  };

  return (
    <div className="w-[800px] h-[500px] rounded-2xl overflow-hidden shadow-2xl backdrop-blur-lg bg-white/10 border border-white/20 p-1">
      <video
        ref={videoRef}
        src={vedio}
        onLoadedMetadata={handleVideoLoaded}
        onEnded={handleVideoEnd}
        muted
        className="w-full h-full object-cover rounded-xl"
      />
    </div>
  );
};

export default Cross;
